import { useEffect, useState } from 'react'

import { Autocomplete, AutocompleteProps } from '@mantine/core'

import {
  STATE_AND_PROVINCE_NAME_GROUPS,
  STATE_AND_PROVINCE_OPTIONS,
} from 'src/lib/usStates'

export interface SelectStateProps extends AutocompleteProps {
  setValue: (value) => void
  disabled?: boolean
  required?: boolean
}

export const SelectState = ({
  value,
  disabled,
  required,
  setValue,
  label = 'Select your state',
}: SelectStateProps) => {
  const state = STATE_AND_PROVINCE_OPTIONS.find(
    (state) => state.value === value
  )
  const [selectedLabel, setSelectedLabel] = useState(state?.label)

  // Update selectedLabel when value prop changes (e.g., from PlacesAutocomplete)
  // Always sync label with value to avoid showing stale labels for invalid values
  useEffect(() => {
    const matchingState = STATE_AND_PROVINCE_OPTIONS.find(
      (state) => state.value === value
    )
    setSelectedLabel(matchingState?.label || '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    const state = STATE_AND_PROVINCE_OPTIONS.find(
      (state) => state.label === selectedLabel
    )
    // Only update if we found a valid state and it's different from current value
    // Don't clear value when user is typing partial text (state would be undefined)
    if (state && state.value !== value) {
      setValue(state.value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLabel])

  return (
    <Autocomplete
      classNames={{
        label: 'text-sm font-medium text-doubleNickel-gray-700',
        input: `cursor-pointer
          ${!disabled ? 'caret-inherit' : 'caret-transparent'}
          [&[data-disabled]]:bg-doubleNickel-white [&[data-disabled]]:opacity-100 [&[data-disabled]]:text-doubleNickel-gray-900 [&[data-disabled]]:border-none [&[data-disabled]]:p-0`,
      }}
      disabled={disabled}
      value={selectedLabel}
      required={required}
      onChange={setSelectedLabel}
      label={label}
      data={STATE_AND_PROVINCE_NAME_GROUPS}
    />
  )
}
